import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import Box from '@mui/material/Box';

const TryAgain = ({percent, lectionId}) => {
  return (
    <> <Box mb={2}>
        <Typography align="left" variant="h4" component="p" color="secondary">
        Durchgefallen <ThumbDownIcon fontSize="large" />
        </Typography>
        <Typography
          align="left"
          variant="body1"
          component="p"
          color="secondary">
          Du hast {percent}% richtig.
        </Typography>
      </Box>
    </>
  );
};
export default TryAgain;
